var OperationExtensionsMap = {};
export var startCapturingExtensions = function startCapturingExtensions(operationName) {
  OperationExtensionsMap[operationName] = OperationExtensionsMap[operationName] || [];
};
export var stopCapturingExtensions = function stopCapturingExtensions(operationName) {
  OperationExtensionsMap[operationName] = undefined;
};
export var putExtensions = function putExtensions(operationName, extension) {
  if (extension !== undefined) {
    var extensionsForOperation = OperationExtensionsMap[operationName];
    if (extensionsForOperation !== undefined) {
      extensionsForOperation.push(extension);
    }
  }
};
export var getExtensions = function getExtensions(operationName) {
  return OperationExtensionsMap[operationName] || [];
};